import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DashboardSkeleton from "../../../../components/skeleton/dashboard";
// Revenue components
import RevenueSummaryCards from "../components/RevenueSummaryCards";
// import RevenueChart from "../components/RevenueChart";
import TopVendors from "../components/TopVendors";
import TopShippers from "../components/TopShippers";
import RevenueDateFilter, {
  presetRange,
} from "../components/RevenueDateFilter";
// APIs
import { getRevenueStatistics } from "../../../../redux/statistics/statisticsAction";

const RevenueReport = () => {
  const dispatch = useDispatch();
  const { isLoading, revenueStats } = useSelector((state) => state.statistics);
  // Shared by the filter and the stats request; defaults to this month
  const [dateRange, setDateRange] = useState(() => presetRange("this_month"));

  useEffect(() => {
    dispatch(
      getRevenueStatistics({
        start_date: dateRange.start_date,
        end_date: dateRange.end_date,
      }),
    );
  }, [dispatch, dateRange.start_date, dateRange.end_date]);

  return (
    <div>
      {/* Stays outside the skeleton so it's usable while stats load */}
      <RevenueDateFilter value={dateRange} onChange={setDateRange} />

      {isLoading ? (
        <DashboardSkeleton />
      ) : (
        <>
          {/* Revenue Summary Cards */}
          <RevenueSummaryCards revenueStats={revenueStats} />

          {/* Revenue Chart */}
          {/* <RevenueChart /> */}

          {/* Top Vendors / Top Shippers: stacked, side by side on wide screens */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 items-start">
            <TopVendors revenueStats={revenueStats} />
            <TopShippers revenueStats={revenueStats} />
          </div>
        </>
      )}
    </div>
  );
};

export default RevenueReport;
